import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
// eslint-disable-next-line
import validator from "validator";
import api from "../../services/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Meta from "../../components/Meta";
import { useHistory } from "react-router-dom";

function StepThree({ prevStep, values }) {
  // eslint-disable-next-line
  const [error, setError] = useState(false);
  const [imgPerfil, setImgPerfil] = useState("");
  const [imgComprovante, setImgComprovante] = useState("");
  const [imgFrente, setImgFrente] = useState("");
  const [imgVerso, setImgVerso] = useState("");
  const [imgCpf, setImgCpf] = useState("");

  // eslint-disable-next-line
  const [dados, setDados] = useState("");

  const history = useHistory();

  // after form submit validating the form data using validator
  const {
    nome,
    cpf,
    email,
    nomeSocial,
    dtNascimento,
    sexo,
    estadoCivil,
    dependente,
    tipoDoc,
    docIdentificacao,
    orgEmissor,
    dtEmissao,
    escolaridade,
    ultimaSerie,
    estudante,
    deficiente,
    nomePai,
    nomeMae,
    naturalidade,
    nacionalidade,
    fone1,
    fone2,
    estado,
    cidade,
    bairro,
    logradouro,
    cep,
    numero,
  } = values;


  console.log(values)

  const submitFormData = async (e) => {
    try {
      e.preventDefault();
      // Create an object of formData
      const formData = new FormData();

      // //Dados do FILES
      formData.append("docPerfil", imgPerfil);
      formData.append("docComprovante", imgComprovante);
      formData.append("docCpf", imgCpf);
      formData.append("docFrente", imgFrente);
      formData.append("docVerso", imgVerso);
      //Dados do FORM
      formData.append("email", email);
      formData.append("nome", nome);
      formData.append("cpf", cpf);
      formData.append("nomeSocial", nomeSocial);
      formData.append("dtNascimento", dtNascimento);
      formData.append("sexo", sexo);
      formData.append("estadoCivil", estadoCivil);
      formData.append("dependente", dependente);
      formData.append("tipoDoc", tipoDoc);
      formData.append("docIdentificacao", docIdentificacao);
      formData.append("orgEmissor", orgEmissor);
      formData.append("dtEmissao", dtEmissao);
      formData.append("escolaridade", escolaridade);
      formData.append("ultimaSerie", ultimaSerie);
      formData.append("estudante", estudante);
      formData.append("deficiente", deficiente);
      formData.append("nomePai", nomePai);
      formData.append("nomeMae", nomeMae);
      formData.append("naturalidade", naturalidade);
      formData.append("nacionalidade", nacionalidade);
      formData.append("fone1", fone1);
      formData.append("fone2", fone2);
      
      formData.append("estado", estado);
      formData.append("cidade", cidade);
      formData.append("bairro", bairro);
      formData.append("logradouro", logradouro);
      formData.append("cep", cep);
      formData.append("numero", numero);

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await api.put("/api/users/userdpg", formData, config);
      setDados(data);
      history.push("/");
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err);
    }
  };

  return (
    <>
      <ToastContainer />
      <Meta />
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg">
                <div className="p-5">
                  <div className="text-center">
                    <h5 className="h5 text-gray-900 mb-4">
                      CADASTRO CLIENTE <br />
                      <small style={{ fontSize: "14px" }}>
                        Público em Geral
                      </small>
                    </h5>
                    <br />

                    <div className="card card-timeline px-1 border-none mb-5">
                      <div className="row">
                        <div className="col-lg-3"></div>
                        <div
                          className="col-lg-7"
                          style={{ paddingLeft: "50px" }}
                        >
                          <ul className="bs4-order-tracking">
                            <li className="step active">
                              <div>
                                <i className="fas fa-user"></i>
                              </div>
                              <label style={{ fontSize: "10px" }}>
                                pessoal{" "}
                              </label>
                            </li>
                            <li className="step active">
                              <div>
                                <i className="far fa-envelope-open"></i>
                              </div>
                              <label style={{ fontSize: "10px" }}>
                                {" "}
                                endereço
                              </label>
                            </li>

                            <li className="step active">
                              <div>
                                <i className="fas fa-file-upload"></i>
                              </div>
                              <label style={{ fontSize: "10px" }}>
                                documentação
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-2"></div>
                      </div>
                    </div>
                  </div>

                  {/* formulario de cadastro  */}

                  <form className="user" onSubmit={submitFormData}>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>FOTO 3X4</label>

                        <input
                          style={{ border: error ? "2px solid red" : "" }}
                          type="file"
                          className="form-control-file"
                          id="file"
                          name="docPerfil"
                          onChange={(e) => {
                            setImgPerfil(e.target.files[0]);
                          }}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG"
                        />
                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                        <p
                          className="text-dark mb-0"
                          style={{ fontSize: "11px" }}
                        >
                          A imagem deve estar na posição <b>retrato</b> e a
                          pessoa deve estar sozinha na foto. Na foto a pessoa
                          não deve usar acessórios tais como: óculos, boné,
                          chapéu ou qualquer outro que dificulte a
                          indentificação.
                        </p>
                      </div>
                      <div className="col-sm-6">
                        <label>COMPROVANTE DE RESIDÊNCIA</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docComprovante"
                          id="file"
                          onChange={(e) => {
                            setImgComprovante(e.target.files[0]);
                          }}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG"
                        />
                        <p
                          className="text-dark mb-0"
                          style={{ fontSize: "11px" }}
                        >
                          Será aceito somente comprovante dos últimos{" "}
                          <b>3 meses</b> considerando a data atual
                        </p>
                      </div>
                    </div>

                    <hr className="mt-4 mb-5" />

                    <div className="form-group row">
                      <div className="form-group col-sm-6">
                        <label>CPF</label>
                        <input
                          type="file"
                          className="form-control-file"
                          name="docCpf"
                          id="file"
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG"
                          onChange={(e) => {
                            setImgCpf(e.target.files[0]);
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>DOCUMENTO DE IDENTIFICAÇÃO - FRENTE</label>
                        <input
                          type="file"
                          className="form-control-file"
                          name="docFrente"
                          id="docFrente"
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.gif,.GIF"
                          onChange={(e) => {
                            setImgFrente(e.target.files[0]);
                          }}
                        />
                      </div>
                      <div className="col-sm-6">
                        <label>DOCUMENTO DE IDENTIFICAÇÃO - VERSO</label>
                        <input
                          type="file"
                          className="form-control-file"
                          name="docVerso"
                          id="file"
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG"
                          onChange={(e) => {
                            setImgVerso(e.target.files[0]);
                          }}
                        />
                      </div>
                    </div>

                    <hr className="mt-4" />
                    <Button
                      onClick={prevStep}
                      className="btn btn-primary btn-user btn-block bg-warning"
                    >
                      Anterior
                    </Button>
                    <Button
                      type="submit"
                      className="btn btn-primary btn-user btn-block"
                    >
                      Continuar
                    </Button>
                  </form>

                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StepThree;